import { axiosHyperwolfDevClient } from "axiosClient";

export async function uploadProductImageAPI(data) {
  const res = await axiosHyperwolfDevClient.post(
    "api/v1/admin/products/upload/image",
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return res?.data ?? res;
}

